import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import { AppContext } from "contexts/AppContext"
import { useContext, useEffect } from "react"
import { Navigate } from "react-router-dom"
import { getOrInitMsalInstance, isImpersonating } from "utils/msalInstance";

const Logout = (props) => {
    const {setUserData, userData, brandData} = useContext(AppContext)
    useEffect(() => {
        const logoutMsal = async () => {
            const msalInstance = await getOrInitMsalInstance(brandData.brandSlug, isImpersonating)
            msalInstance.logoutRedirect({
                postLogoutRedirectUri: '/login',
            });
        }

        const token = localStorage.getItem('accessToken')
        if(userData && userData.UserID && !token) {
            setUserData(null)
        }

        if (brandData?.features?.enableMsalAuth) {
            logoutMsal()
        }
    }, [userData, setUserData, brandData]);

    if (brandData?.features?.enableMsalAuth) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem' }}>
                <CircularIndeterminate size={100} />
            </div>
        )
    }

    return <Navigate to="/login" />;
}
export default Logout 